export default __webpack_public_path__ + "static/media/chairx.00a93a64.png";